// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutActions-InstructButtonWrapper_cls1__qTb5I","cls2":"PayoutActions-InstructButtonWrapper_cls2__S9-Eg PayoutActions-InstructButtonWrapper_cls1__qTb5I"};